var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    attrs: { src: _vm.url, loading: "lazy", alt: "hotel image" },
    on: {
      click: function ($event) {
        return _vm.$emit("click", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }